
const LandingHeader = () => {
  return (
    <header className="container max-w-6xl mx-auto px-4 py-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center shadow-sm">
            <img 
              src="/lovable-uploads/3848e4a0-cee7-43d6-81a6-66811064660c.png" 
              alt="Show Up! Logo"
              className="w-8 h-8 object-contain"
            />
          </div>
          <h1 className="text-2xl font-bold text-deep-blue">Show Up!</h1>
        </div>
        <div className="flex items-center gap-2 text-sm">
          <div className="w-2 h-2 bg-vibrant-orange rounded-full animate-pulse"></div>
          <span className="text-deep-blue/70 font-medium">Coming Soon</span>
        </div>
      </div>
    </header>
  );
};

export default LandingHeader;
